"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HEIGHT_MOBILE_TABLET = exports.HEIGHT_MOBILE_LARGE = exports.HEIGHT_MOBILE_SMALL = exports.HEIGHT_MOBILE_LANDSCAPE = exports.HEIGHT_DESKTOP = exports.HEIGHT_MOBILE = void 0;
exports.HEIGHT_MOBILE = 324;
exports.HEIGHT_DESKTOP = 630;
exports.HEIGHT_MOBILE_LANDSCAPE = 212;
exports.HEIGHT_MOBILE_SMALL = 260;
exports.HEIGHT_MOBILE_LARGE = 380;
exports.HEIGHT_MOBILE_TABLET = 620;
//# sourceMappingURL=fdr-media-gallery.constants.js.map